import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNooz(props) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={"NOOZ.AI™: Bringing Clarity to News in a Biased Media Landscape"}
      image={require("../../../assets/images/partners/logo-nooz.png")}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>NT CONNECT</NtCaseStudyTextBold> is a global
        technology company that designs and operates communication and IT
        solutions for corporate enterprises and government clients. With a track
        record of delivering mission-critical innovations, NT CONNECT continues
        to expand its portfolio with AI-driven applications that promote
        transparency and digital trust.{"\n\n"}
        <NtCaseStudyTextBold>Challenge</NtCaseStudyTextBold>
        {"\n\n"}In an era of increasing media polarization, misinformation, and
        declining public trust in journalism, consumers often struggle to
        distinguish between objective reporting and opinion-laced content. Pew
        Research found that only 58% of U.S. adults trust news organizations, the
        lowest level in five years. Readers are often unaware of the subtle ways
        language and presentation can manipulate their perception of news
        topics.{"\n\n"}NT CONNECT identified a critical need: a solution that
        helps consumers actively recognize bias, sentiment, and persuasive
        techniques in news content, before they form an opinion.{"\n\n"}
        <NtCaseStudyTextBold>Solution</NtCaseStudyTextBold>
        {"\n\n"}NT CONNECT launched NOOZ.AI™, a free mobile news aggregator app
        available on iOS and Android. The app leverages an AI-powered language
        analysis engine to assess the bias embedded in global news articles.
        {"\n\n"}NOOZ.AI™ provides transparency through four analytical pillars:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Opinion Analysis</NtCaseStudyTextBold> – Detects
        the presence of personal beliefs or judgments within news content.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Sentiment Analysis</NtCaseStudyTextBold> – Measures
        whether a journalist's tone is supportive or antagonistic toward the
        topic.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Propaganda Analysis</NtCaseStudyTextBold> – Flags
        up to 18 known persuasion techniques used to subtly influence readers.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Revision Analysis</NtCaseStudyTextBold> – Allows
        users to view how an article has changed over time and track any shifts
        in tone or narrative.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        Each article is scored numerically:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Opinion Score (0–100)</NtCaseStudyTextBold>
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Sentiment Score (-100 to 100)</NtCaseStudyTextBold>
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Article revisions are logged and displayed for transparency.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        This analytical framework empowers readers to approach news with
        critical thinking and objectivity.{"\n\n"}
        <NtCaseStudyTextBold>Results</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Successful public launch</NtCaseStudyTextBold> of
        NOOZ.AI™ on both iOS and Android platforms.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Developed a proprietary scoring system that quantifies media bias, a
        first in consumer-focused news apps.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Early user feedback highlights enhanced reader awareness and reduced
        emotional influence by biased articles.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Positioned NT CONNECT as an innovator in the AI + media transparency
        space.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Impact</NtCaseStudyTextBold>
        {"\n\n"}NOOZ.AI™ is more than a news app. It’s a digital literacy tool
        designed for the modern information environment. By helping readers
        detect bias at the language level, the app encourages informed reading
        habits and resists manipulation from slanted journalism.{"\n\n"}
        According to Garry Paxinos, CTO of NT CONNECT:
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{
          marginTop: 20,
          fontStyle: "italic",
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        “Language itself can be used to manipulate and persuade the casual
        reader. Our goal is not to label news as ‘true or false’ but to reveal
        how persuasive language works, and empower users to think critically.”
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{
          marginTop: 20,
        }}
      >
        With NOOZ.AI™, NT CONNECT contributes to a healthier, more accountable
        media ecosystem, starting with awareness.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNooz;
